import EditAttachmentsLightBoxContainer from './EditAttachmentsLightBoxContainer';

export default EditAttachmentsLightBoxContainer;
